export default __webpack_public_path__ + "../staticImages/error500.jpg";